import { DummyReelSymbol, ReelInit, ReelObject } from "./ReelInit";

import { Group, Tween } from "tweedle.js";

import { getSymbol } from "../../config/getSymbol";

import { isQuickBtnOnGlobal, isSlamClickedGlobal, isSuperQuickBtnOnGlobal, setIsSlamClickedGlobal } from "../../config/GlobalVariableConfig";


import {
    REEL_NUMBERS,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../../config/reelConfig";

import { spinData } from "../../server/getServerResposesFun";

import { IMediaInstance, sound } from "@pixi/sound";
import { BitmapText } from "pixi.js";
import { TransCoinsComponent } from "../../components/TransCoins/TransCoinsComponent";
import { Manager } from "../../core/Manager";
import { DisplayComponent } from "../displays/DisplayComponent";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";

const reelTweenGroup = new Group();

export class ReelSpin extends ReelInit {

    public running = false;
    public isBetDecline = false;

    private movingSteps: number[];

    private reelSounds: (IMediaInstance | null)[] = [];

    constructor() {
        super();

        this.movingSteps = [];

        this.setReelSpinSound();

    }


    private setReelSpinSound(): void {
        this.reelSounds = new Array(REEL_NUMBERS).fill(null);
    }


    private playReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        // Stop old instance if exists
        this.reelSounds[reelIndex]?.stop();

        this.reelSounds[reelIndex] = sound.play(SoundConstants.REELS_SPIN, {
            loop: true,
            volume: 1 / REEL_NUMBERS,
        }) as IMediaInstance;
    }


    private stopReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        this.reelSounds[reelIndex]?.stop();
        this.reelSounds[reelIndex] = null;
    }


    private stopAllReelSounds(): void {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.stopReelSound(i);
        }
    }


    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();

    }


    public async startReels(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {
        try {

            console.log(`startReels this.running ${this.running}`);

            // if (this.running) {
            //     return;
            // }

            // this.spinStype = spinStype;

            this.running = true;

            this.isBetDecline = false;
            setIsSlamClickedGlobal(false);

            // this.slamClicked = false;
            // this.quickStop = this.ui.burgerMenuObj.isTurboBtnOn;


            // make container's symbols visible before spinning
            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                this.allReelArray[reelNum].container.visible = true;
            }

            if (isNewSpin) {
                this.resetReelOverlayContainer();
            }

            // get the spin response from the server
            // this.fetchSpinResponse(spinStype, buyAmount);  // please note that no await here

            //wait for data
            // await this.waitForData();

            // console.log("spinData", spinData);

            // spinData = spinData;

            this.getMovingSteps(isNewSpin);

            /********** handling of slam button *********************/

            // this.slamClicked = false;
            // this.slamButtomHandle();

            // get the anticipation array, set in anticipationReels []

            /****  actual reel play ***************************** */


            await this.reelSpinFun(RespinIndex, isNewSpin, spinStype);

        } catch (error: any) {
            console.log("inside catch of startPlay");
            throw (error);
        }

    }


    // Function that returns a promise which resolves when dataFetched is true
    // private waitForData(): Promise<void> {
    //     return new Promise<void>((resolve) => {

    //         if (spinData.dataFeatched) {
    //             resolve();
    //         }

    //         const checkInterval = setInterval(() => {
    //             if (spinData.dataFeatched) {
    //                 clearInterval(checkInterval);
    //                 resolve();
    //             }
    //         }, 100); // Check every 100ms

    //     });
    // }


    // private slamClickHandler() {
    //     // Reset the slamClicked flag and UI state

    //     if (this.slamClicked || isTurboBtnOn) {
    //         return;
    //     }


    //     console.log("slamClick");
    //     this.slamClicked = true;
    //     this.ui.slam.alpha = 0.50;

    //     // if (this.normalReelPlayStarted) {
    //     //     this.slamButtonPlay();
    //     // }

    // }


    private getMovingSteps(isNewSpin: boolean) {

        console.log("inside getMovingSteps");

        if (!isNewSpin) {
            this.movingSteps = [1, 1, 1, 1, 1];
            return;
        }

        let scatterAppear: number[] = [];

        // spinData.reelSymbols.forEach(row => {
        //     let appearFlag = row.find(pos => pos === 9) ? 1 : 0;  // 7 is the scatter id
        //     scatterAppear.push(appearFlag);
        // });


        const anticipationAfterGetting = 2;
        let scatterExist: number[] = [1, 1, 1, 1, 1]; // scatter appear on reels
        let ancipation: number[] = [];

        let sum = 0;
        scatterAppear.forEach((val, i) => {
            sum += val;

            if (sum - val >= anticipationAfterGetting && scatterExist[i] == 1) {
                ancipation.push(1);
            }
            else {
                ancipation.push(0);
            }

        })

        this.movingSteps = [1, 5, 10, 15, 20];

        // (initData.spinTime >= 5000 && this.spinStype === "BASE") ?
        //     [1, 3, 5, 7, 9]
        //     :
        //     [1, 2, 3, 4, 5]
        // ;

        let additionalSteps = 0;
        for (let i = 0; i < this.movingSteps.length; i++) {
            if (ancipation[i] === 1) {
                additionalSteps += 5;
            }
            this.movingSteps[i] += additionalSteps; // Add 10 to movingSteps at index i
        }
        // return ancipation;

        // return [0, 0, 0, 0, 0]

    }

    private async landingAnimation(reelNum: number, RespinIndex: number): Promise<void> {


        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        const coinCollect = spinData.respins[RespinIndex].coinCollect;

        let coinLanded = false;
        for (let j = 0; j < SYMBOLS_PER_REEL; j++) {

            const posNum = j;

            // const symbol = this.reelOverlayContainer.getChildByLabel(`${reelNum * SYMBOLS_PER_REEL + posNum}`) as Spine;
            const symbol = this.reelSymbols[reelNum][posNum];

            const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

            if ([12, 16, 17, 18].includes(symbolId)) { // coin symbols
                coinLanded = true;
            }

            // coinCollect[reelNum][posNum]
            if (![13, 14, 15].includes(symbolId)) {
                const animationPromise = new Promise<void>(async (resolve) => {
                    let listener = {
                        complete: async () => {
                            resolve();
                            symbol.state.removeListener(listener);

                            if (coinCollect[reelNum][posNum] > 0) {
                                // call trail animation and wait for its completion

                                //const coinValue = spinData.respins[RespinIndex].coinValues[reelNum][posNum];

                                //await this.playTrailAnimation(coinCollect[reelNum][posNum], reelNum, posNum, coinValue);

                                resolve();
                            } else {
                                resolve();
                            }
                        }
                    };
                    symbol.state.addListener(listener);
                    symbol.state.setAnimation(0, "land", false);
                    symbol.state.timeScale = timeScale;
                });
                animationPromises.push(animationPromise);
            }
            else { // if coin symbol, directly resolve after animation without waiting for trail animation
                const transformCoins = spinData?.respins?.[0]?.transformCoins;
                if (transformCoins && transformCoins.length > 0) {
                    const animationPromise = new Promise<void>(async (resolve) => {
                        await DisplayComponent.get(TransCoinsComponent).transformSymbol(transformCoins, reelNum, j, resolve);
                    });
                    animationPromises.push(animationPromise);
                }
            }
            //return new Promise<void>(async (resolve) => {
            //});



        }


        if (coinLanded) {
            sound.play('coin_appear_sound', { volume: 1, speed: timeScale });
        } else {
            sound.play(SoundConstants.REEL_STOP, { volume: 1, speed: timeScale });
        }

        await Promise.all(animationPromises);

    }


    protected playTrailAnimation(coinType: number, reelNum: number, posNum: number, coinValue: number): Promise<void> {
        coinType;
        return new Promise<void>((resolve) => {


            // trail animation numbering is as follows :
            // 1	4	7	10	13
            // 2	5	8	11	14
            // 3	6	9	12	15


            // const animationIndex = reelNum * SYMBOLS_PER_REEL + posNum; // 0-based index
            // const animationNumber = animationIndex + 1; // make it 1-based (1–15)

            // let trail: Spine;
            // let animationPrefix: string;

            // switch (coinType) {
            //     case 1: //"greenTrail":
            //         trail = this.greenTrail;
            //         animationPrefix = "double_trail_";
            //         break;
            //     case 2: //"blueTrail":
            //         trail = this.blueTrail;
            //         animationPrefix = "extra_trail_";
            //         break;
            //     case 3: //"pinkTrail":
            //         trail = this.pinkTrail;
            //         animationPrefix = "multi_trail_";
            //         break;
            //     default:
            //         console.warn(`Unknown coin type: ${coinType}`);
            // }


            // const listener = {
            //     event: (_entry: any, event: any) => {
            //         if (event.data.name === "trail_hit") {
            //             reelSpinEmitter.emit('potCollect', coinType);
            //             sound.play('witch_symbol_hit', { volume: 0.3 });
            //             trail.state.removeListener(listener);
            //         }
            //     }
            // };

            // // Add listener
            // trail.state.addListener(listener);

            // // Play animation
            // trail.state.setAnimation(animationIndex, `${animationPrefix}${animationNumber}`, false);
            // sound.play('witch_symbol_trail', { volume: 0.5 });

            const symbol = this.reelSymbols[reelNum][posNum];

            const coinValText = new BitmapText({
                text: `${coinValue}x`,
                style: {
                    fontFamily: "3God_coin",
                    fontSize: 30,
                    // letterSpacing: 10,
                }
            });
            coinValText.anchor = 0.5;


            // To reveal the coin value after flip animation, using a spine placeholder event
            symbol.state.setAnimation(0, "flip", false).listener = {

                event: (_entry: any, event: any) => {
                    console.log("Event triggered:", event.data.name);
                    // sound.play('witch_symbol_flip', { volume: 0.5 });
                    if (event.data.name === "reveal_amount") {
                        symbol.addSlotObject("amount", coinValText)
                    }
                    const coinValTextScale = Math.min(120 / coinValText.width, 1);
                    coinValText.scale = coinValTextScale;
                },

                complete: () => {
                    symbol.state.clearListeners();
                    // symbol.state.setAnimation(0, "idle", true);
                    const tween = new Tween(symbol, reelTweenGroup)
                        .to({ alpha: 1 }, 100)
                        .onComplete(() => {
                            reelTweenGroup.remove(tween);
                        })
                        .start();

                    resolve();
                }
            };

            //console.log(`coin animation : ${animationPrefix}${animationNumber}`);

        })
    };


    private async reelSpinFun(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("reelSpinFun", isNewSpin, spinStype);

        // this.anticipationReels = [0,1,0,1,0]

        // const movingSteps: number[] = [1, 2, 3, 4, 5];

        // this.getAnticipationArray(spinData.reelSymbols);

        // sound.play('reels_spinning', { loop: true, volume: 1 })

        const promises: Promise<void>[] = [];

        // Loop over each reel object in the allReelArray

        this.allReelArray.forEach((reelObj, index) => {
            // Create a promise that chains multiple moveReel calls based on the index
            const promise = new Promise<void>(async (resolve) => {

                this.playReelSound(index);

                while (!spinData.dataFeatched && !this.isBetDecline) {
                    const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                    this.swapTopSymbol(reelObj, dummySymbolId);
                    await this.moveReelStep(reelObj);

                    if (this.isBetDecline) {
                        this.stopAllReelSounds();
                        // break;
                    }
                }
                if (!this.isBetDecline) {
                    let i = 0;
                    while (i < this.movingSteps[index]) {

                        if ((isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal || isSlamClickedGlobal || this.isBetDecline)) {
                            break;
                        }

                        const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                        this.swapTopSymbol(reelObj, dummySymbolId);
                        await this.moveReelStep(reelObj);
                        i++;
                    }
                }

                await this.moveReelFinal(reelObj, RespinIndex);

                this.stopReelSound(index);

                this.addReelSymbolsToContainer(index);
                if (!this.isBetDecline) {
                    await this.landingAnimation(index, RespinIndex);
                }

                // await this.playAnticipation(index);
                resolve();

            });

            promises.push(promise);

        });

        await Promise.all(promises);
        sound.stop(SoundConstants.REELS_SPIN);

        await this.allReelStop();

        if (this.isBetDecline) { // if bet is decline no need to go further for battleTrigger
            return;
        }

        if (isNewSpin && spinStype === "BASE") {
            Manager.casinoChannelHandler.reportResultDisplay();
        }

    }


    private dummyReelSymbolQueues: number[][] = [];

    private getNextRandomSymbol(reelNum: number): number {
        // Initialize queue if not yet
        if (!this.dummyReelSymbolQueues[reelNum]) {
            this.dummyReelSymbolQueues[reelNum] = [];
        }

        // If queue is empty, refill it
        if (this.dummyReelSymbolQueues[reelNum].length === 0) {
            const reelData = DummyReelSymbol[reelNum];
            const maxStartIndex = reelData.length - SYMBOLS_PER_REEL;
            const randomStart = Math.floor(Math.random() * maxStartIndex);
            const newSlice = reelData.slice(randomStart, randomStart + SYMBOLS_PER_REEL);

            this.dummyReelSymbolQueues[reelNum].push(...newSlice);
        }

        // Pop the next symbol from the queue
        const dummyReelSymbol = this.dummyReelSymbolQueues[reelNum].shift();
        return dummyReelSymbol;
    }


    private async moveReelFinal(reelObj: ReelObject, RespinIndex: number): Promise<void> {
        return new Promise(async (resolve) => {
            const reelNum = reelObj.reelIndex;

            let finalReelData: number[];

            if (!this.isBetDecline) {
                finalReelData = spinData.respins[RespinIndex].reelSymbols[reelNum];
            } else {
                finalReelData = this.reelSymbolsBeforeSpin[reelNum];
            }

            for (let i = 0; i < finalReelData.length; i++) {
                const symbolId = finalReelData[finalReelData.length - 1 - i];

                this.swapTopSymbol(reelObj, symbolId);
                await this.moveReelStep(reelObj);

                if (i == finalReelData.length - 1) {
                    this.reArrangeTheSymbolOrder(reelObj);
                }
            }

            resolve();
        });
    }


    private swapTopSymbol(reelObj: ReelObject, symbolId: number) {
        const topSymbol = reelObj.symbols[SYMBOLS_PER_REEL];
        topSymbol.id = symbolId;
        topSymbol.symbol.texture = getSymbol(symbolId);
    }


    private reArrangeTheSymbolOrder(reelObj: ReelObject) {
        // Re-add them in correct order (important for rendering layer)
        reelObj.symbols.forEach((s) => {
            reelObj.container.addChild(s.view);
        });
    }


    private async moveReelStep(reelObj: ReelObject): Promise<void> {

        const movetime = isSuperQuickBtnOnGlobal ? 10 : (isQuickBtnOnGlobal ? 20 : 40);

        return new Promise((resolve) => {
            const totalSymbols = reelObj.symbols.length;
            let completed = 0;

            // Move each symbol visually
            reelObj.symbols.forEach((symbol) => {
                const symbolContainer = symbol.view;

                const tween = new Tween(symbolContainer, reelTweenGroup)
                    .to({ y: symbolContainer.y + SYMBOL_HEIGHT }, movetime)
                    .onComplete(() => {
                        reelTweenGroup.remove(tween);
                        completed++;

                        // Once all tweens complete
                        if (completed === totalSymbols) {

                            // Move last symbol visually to top
                            const movedSymbol = reelObj.symbols.pop();
                            if (movedSymbol) {
                                movedSymbol.view.y = - (SYMBOL_HEIGHT / 2);
                                movedSymbol.y = movedSymbol.view.y;
                                reelObj.symbols.unshift(movedSymbol);
                            }

                            // Update symbolIndex and view.y of all symbols
                            reelObj.symbols.forEach((s, i) => {
                                s.symbolIndex = i;
                                s.view.y = i === SYMBOLS_PER_REEL
                                    ? - (SYMBOL_HEIGHT / 2)
                                    : (SYMBOL_HEIGHT / 2) + i * SYMBOL_HEIGHT;
                                s.y = s.view.y;
                            });


                            resolve();
                        }
                    })
                    .start();
            });
        });
    }


    public resetSymbolPositions() {

        this.allReelArray.forEach((reelObj) => {

            reelObj.symbols.forEach((symbol) => {
                const targetPos = symbol.y;
                const symbolContainer = symbol.view;
                symbolContainer.y = targetPos;

            })

        })
    }


    private async allReelStop() {

        // this.ui.spin.interactive = true;

        // this.running = false;
        console.log("reel spin done");

        // const delayStopTime = isSuperQuickBtnOnGlobal ? 0 : 100;

        // await new Promise((resolve) => setTimeout(resolve, delayStopTime));

        // this.ui.spin.visible = true;
        // this.ui.slam.visible = false;

        // console.log(sound.isPlaying('reel_spin_loop'));

        // sound.stop('reel_spin_loop');
        // this.stopReelSpinSound=true;

        // sound.stop('reel_spin_loop');

        // sound.pause('anticipation')

        // await this.waitAfterReelStop(200);

        // Resolve the promise to signal that all work is done
        // if (this.resolveReelsStop) {
        //     this.resolveReelsStop();
        //     this.resolveReelsStop = null; // Reset the resolver
        // }

    }
    // Add other methods as needed
}
